<template>
  <div>
    <template v-if="isDev || !active">
      <slot></slot>
    </template>
    <template v-if="!isDev && active">
      <span>
        <slot></slot>
      </span> <v-icon
        small
        @click="showEdit"
        class="eicon"
      >fas fa-edit</v-icon>
      <modal-form
        :show="dialog"
        :title="formatedTitle"
        @update:show="dialog=$event"
        v-on:saveData="doSave"
      >
        <v-alert
          color="red"
          dark
          v-if="error"
        >{{ error }}</v-alert>
        <v-form
          v-model="valid"
          ref="form"
        >
          <v-row>
            <v-col
              cols="4"
              v-if="type=='text'"
            >
              <text-field
                :label="title"
                v-model="internalValue"
              ></text-field>
            </v-col>
            <v-col
              cols="4"
              v-if="type=='boolean'"
            >
              <switch-button
                :label="title"
                :value="internalValue"
                @change="internalValue = $event"
              ></switch-button>
            </v-col>
            <v-col
              cols="4"
              v-if="type=='date'"
            >
              <date-picker
                :label="title"
                v-model="internalValue"
              ></date-picker>
            </v-col>
            <v-col
              cols="4"
              v-if="type=='codelist'"
            >
              <antenna
                :label="title"
                v-model="internalValue"
                v-if="codelist=='antenna'"
              ></antenna>

              <pred-model-type
                  :label="title"
                  v-model="internalValue"
                  v-if="codelist=='pred_model'"
              >
              </pred-model-type>

              <property-type
                :label="title"
                v-model="internalValue"
                v-if="codelist=='property_type'"
              >
              </property-type>
            </v-col>
          </v-row>
        </v-form>
      </modal-form>
    </template>
  </div>
</template>

<script>
  import ModalForm from '@/components/ModalForm'
  import TextField from '@/components/TextField'
  import SiteNwpService from '@/services/site-nwp'
  import DatePicker from '@/components/DatePicker'
  import Constants from '@/constants'
  import Antenna from './codelist/Antenna'
  import SwitchButton from './SwitchButton'
  import PredModelType from './codelist/PredModelType'
  import PropertyType from './codelist/PropertyType'

  export default {
    name: 'EditReadField',
    components: { PropertyType, PredModelType, SwitchButton, Antenna, DatePicker, TextField, ModalForm },
    props: {
      site: {
        default: undefined,
      },
      active: {
        default: false,
      },
      title: {
        default: null,
      },
      field: {
        default: null,
      },
      type: {
        default: 'text',
      },
      value: {
        default: null,
      },
      aid: {
        default: null,
      },
      codelist: {
        default: null,
      },
      updateParams: {
        default: {},
      },
    },
    data () {
      return {
        dialog: false,
        valid: false,
        internalValue: null,
        error: undefined,
      }
    },
    computed: {
      formatedTitle () {
        return 'Edit ' + this.title
      },
      isDev () {
        return Constants.isDev()
      },
    },
    watch: {
      value: function () {
        this.internalValue = this.value
      },
    },
    mounted () {
      this.internalValue = this.value
      this.error = null
    },
    methods: {
      showEdit () {
        this.dialog = true
      },
      doSave () {
        this.error = undefined
        const ns = new SiteNwpService()
        const data = {
          field: this.field,
          value: this.internalValue,
          aid: this.aid,
          params: this.updateParams,
        }
        ns.update(this.site.id, data).then((response) => {
          if (response.data === 'OK') {
            this.dialog = false
            this.$emit('updated', this.internalValue)
          } else {
            this.error = response.data
          }
        })
      },
    },
  }

</script>

<style scoped>
 .link {
   display: inline-block;
   padding: 0px 10px 0px 0px;
   min-width: 50px;
 }
 .eicon {
   position: relative;
   margin-top: -5px;
   margin-left: 5px;
 }
</style>
